import { useMutation } from '#react-query';
import { deleteMedia } from '../../services';

type DeleteFile = {
  fileId: string;
};

export const useDeleteFileMutation = () =>
  useMutation<unknown, Error, DeleteFile>({
    async mutationFn({ fileId }: DeleteFile) {
      await deleteMedia({ routeParams: { id: fileId } });
    },
  });
